module.exports = __webpack_public_path__ + "static/hotblack-coffee-hero-6bbcf8cac9594b77c34b146b08305a8f.jpg";